<template>
    <div class="mx-8 cropper-wrapper">
        <cropper
            ref="cropper"
            class="cropper-wrapper__cropper"
            :src="src"
            :stencil-props="stencilProps"
        />
    </div>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

export default {
    name: 'ImageCropper',
    components: {
        Cropper,
    },
    props: {
        file: null,
        aspectRatio: {
            type: String,
            default: null,
        },
        scaleFactor: {
            type: Number,
            default: 2,
        },
    },
    computed: {
        stencilProps() {
            const props = {};
            if (this.aspectRatio) {
                if (this.aspectRatio.indexOf(':') !== -1) {
                    let [a, b] = this.aspectRatio.split(':');
                    props.aspectRatio = parseFloat(a) / parseFloat(b);
                }
            }
            return props;
        },
    },
    data() {
        return {
            src: null,
        };
    },
    watch: {
        file() {
            this.updateSrc();
        },
    },
    mounted() {
        this.updateSrc();
    },
    methods: {
        async updateSrc() {
            if (!this.file) return;
            const result = await toBase64(this.file).catch((e) => Error(e));
            if (result instanceof Error) {
                console.log('Error: ', result.message);
                return;
            }
            return (this.src = result);
        },
        crop() {
            return new Promise((resolve) => {
                const { canvas } = this.$refs.cropper.getResult();
                canvas.toBlob((file) => {
                    let f = file;
                    f.name = this.file.name;
                    f.filename = this.file.name;
                    resolve(f);
                }, this.file.type);
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.cropper-wrapper {
    overflow: hidden;
    max-height: 450px;
    width: 80%;

    &__cropper {
        max-height: 600px;
        width: 70%;
        margin: auto;
    }
}
</style>
